"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorBoundary = _interopRequireDefault(require("../../misc/ErrorBoundary"));

var _I18nWrap = _interopRequireDefault(require("../../i18n/I18nWrap"));

var _Main = _interopRequireDefault(require("./Main"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ProfileImageEditor = ({
  _submitImgHandler,
  error,
  imgSrc,
  locale
}) => /*#__PURE__*/_react.default.createElement(_I18nWrap.default, {
  locale: locale
}, /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, null, /*#__PURE__*/_react.default.createElement(_Main.default, {
  _submitImgHandler: _submitImgHandler,
  error: error,
  imgSrc: imgSrc
})));

ProfileImageEditor.propTypes = {
  /** Accepts argument of Base 64 encoded image data */
  _submitImgHandler: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  imgSrc: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string
};
ProfileImageEditor.defaultProps = {
  error: false,
  locale: 'en'
};
var _default = ProfileImageEditor;
exports.default = _default;